/* A-Z jump momentum scroll: instead of the native instant/uniform jump, letter
   clicks "tip then roll" — a long accelerating build-up through ~70% of the
   distance, then a quick quadratic settle (piecewise curve with matched slopes at
   the joint, so there is no visible kick). Cancels on any user scroll input;
   honours prefers-reduced-motion by falling back to the native jump. */
(function () {
  if (window.axDirScroll) return;
  window.axDirScroll = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var raf = null;

  function tipRoll(t) {
    if (t < 0.78) { var u = t / 0.78; return 0.7 * u * u * u; }
    var v = (t - 0.78) / 0.22;
    return 0.7 + 0.3 * (1 - (1 - v) * (1 - v));
  }

  function cancel() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
  }
  window.addEventListener('wheel', cancel, { passive: true });
  window.addEventListener('touchstart', cancel, { passive: true });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.ax-mdir__jump a[href^="#"]');
    if (!link) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    var to = target.getBoundingClientRect().top + window.scrollY - margin;
    to = Math.max(0, Math.min(to, document.documentElement.scrollHeight - window.innerHeight));
    if (reduced.matches) {
      window.scrollTo(0, to);
      history.replaceState(null, '', link.getAttribute('href'));
      return;
    }
    var from = window.scrollY;
    var dist = to - from;
    if (Math.abs(dist) < 4) return;
    var duration = Math.min(1300, 420 + Math.abs(dist) * 0.28);
    var start = null;
    cancel();
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      window.scrollTo(0, from + dist * tipRoll(t));
      if (t < 1) {
        raf = requestAnimationFrame(step);
      } else {
        raf = null;
        history.replaceState(null, '', link.getAttribute('href'));
      }
    }
    raf = requestAnimationFrame(step);
  });
})();
